import * as React from "react";
import {
  ResultCard,
  ResultCardLinkHeading,
  ResultCardLinkHeadingProps,
} from "./ResultCard";
import { Analytics } from "@skv/core";

interface SuggestedOpportunityProps {
  to: ResultCardLinkHeadingProps["to"];
  title: string;
  organisation: string;
}
export const SuggestedOpportunity: React.FC<SuggestedOpportunityProps> = ({
  title,
  organisation,
  to,
}) => {
  return (
    <>
      <ResultCard className="pt-4 pb-2">
        <ResultCardLinkHeading
          to={to}
          title={title}
          css={`
            font-size: 1.25rem;
          `}
          stretchedLink={true}
        />
        <p className="mt-n1">{organisation}</p>
      </ResultCard>

      <Analytics
        data={{
          subSection: "volunteers",
          subSubSection: "activity",
          subSubSubSection: "suggested-opportunity",
          pageTitle: "suggested-opportunity",
          loginStatus: "loggedin",
        }}
      />
    </>
  );
};
